import { Card, CardContent, Typography } from '@mui/material';
import { ReactNode } from 'react';

interface CardBoxProps {
  children: ReactNode;
}

const CardBox = ({ children }: CardBoxProps) => {
  return (
    <Card sx={{ mt: 2, p: 0, mb: 2 }}>
      <CardContent>
        <Typography color="text.primary" variant="h5" component="div" sx={{ mb: 2 }}>
          {children}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default CardBox;
